// extracted by mini-css-extract-plugin
export default {"background":"ErrorPage_background__lZS7H","container":"ErrorPage_container__PW77Y","errorPage":"ErrorPage_errorPage__7E-id"};